import React, { Component } from "react";
import { Button, Modal, Form, Row, Col, Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";

export default class CrossTeamCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      hasDependency: "",
      selectedDeveloper: "",
      employees: [],
    };
  }

  componentDidMount() {
    this.fetchEmployees();
  }

  fetchEmployees = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/listActive", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list || [] });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  handleConfirm = () => {
    if (this.state.hasDependency === "yes" && !this.state.selectedDeveloper) {
      toast.warning("Please select a developer for cross-team changes");
      return;
    }

    if (this.props.onConfirm) {
      this.props.onConfirm({
        hasCrossTeamDependency: this.state.hasDependency === "yes" ? 1 : 0,
        assignedCrossTeamDev:
          this.state.hasDependency === "yes"
            ? this.state.selectedDeveloper
            : null,
      });
    }
  };

  handleSkip = () => {
    if (this.props.onConfirm) {
      this.props.onConfirm({
        hasCrossTeamDependency: 0,
        assignedCrossTeamDev: null,
      });
    }
  };

  render() {
    const { show, onClose, requestType } = this.props;
    const crossType = requestType === "UI" ? "backend (API)" : "frontend (UI)";

    return (
      <Modal show={show} onHide={onClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Cross-Team Dependency Check</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Badge bg={requestType === "UI" ? "primary" : "success"} className="me-2">
              {requestType} Request
            </Badge>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>
              <strong>
                Are there any {crossType} changes needed for this deployment?
              </strong>
            </Form.Label>
            <div className="mt-2">
              <Form.Check
                type="radio"
                id="dep-no"
                name="dependency"
                label="No - Proceed directly to Team Lead approval"
                value="no"
                checked={this.state.hasDependency === "no"}
                onChange={(e) =>
                  this.setState({ hasDependency: e.target.value })
                }
              />
              <Form.Check
                type="radio"
                id="dep-yes"
                name="dependency"
                label={`Yes - I need to assign a ${crossType} developer`}
                value="yes"
                checked={this.state.hasDependency === "yes"}
                onChange={(e) =>
                  this.setState({ hasDependency: e.target.value })
                }
                className="mt-2"
              />
            </div>
          </Form.Group>

          {this.state.hasDependency === "yes" && (
            <Form.Group className="mb-3">
              <Form.Label>
                Select {crossType.replace("(", "").replace(")", "")} Developer
              </Form.Label>
              <Form.Select
                value={this.state.selectedDeveloper}
                onChange={(e) =>
                  this.setState({ selectedDeveloper: e.target.value })
                }
              >
                <option value="">-- Select Developer --</option>
                {this.state.employees.map((emp) => (
                  <option
                    key={emp.employees_Id}
                    value={emp.employees_Id}
                  >
                    {emp.fName} {emp.lName} - {emp.eId}
                  </option>
                ))}
              </Form.Select>
              <Form.Text className="text-muted">
                This developer will be notified and asked to raise the{" "}
                {crossType} deployment request.
              </Form.Text>
            </Form.Group>
          )}

          {this.state.hasDependency === "yes" && (
            <div className="alert alert-info">
              <strong>What happens next:</strong>
              <ul className="mb-0 mt-1">
                <li>
                  Your {requestType} request will wait for the linked developer
                </li>
                <li>
                  The assigned developer will raise the {crossType} request
                </li>
                <li>
                  Your request goes to the{" "}
                  {requestType === "UI" ? "UI" : "API"} Team Lead
                </li>
                <li>
                  The linked request goes to the{" "}
                  {requestType === "UI" ? "API" : "UI"} Team Lead
                </li>
                <li>Both must be approved before deployment</li>
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={this.handleConfirm}
            disabled={!this.state.hasDependency}
          >
            {this.state.hasDependency === "yes"
              ? "Assign & Continue"
              : "Continue to Approval"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
